export var InvoiceEventType;
(function (InvoiceEventType) {
    /** When PAIDNICE first inserted the invoice, NOT the issue date */
    InvoiceEventType["IMPORTED"] = "imported";
    /** When any status changes to `paid` anytime as long as the prior status was not paid */
    InvoiceEventType["PAID"] = "paid";
    /** When `paid` changes to `authorised` */
    InvoiceEventType["PAYMENT_REVERSED"] = "payment_reversed";
    /** When any status changes to void for first time */
    InvoiceEventType["VOIDED"] = "voided";
    /** When the due date changes */
    InvoiceEventType["DUE_DATE_CHANGED"] = "due_date_changed";
    /** When the invoice is frozen automatically */
    InvoiceEventType["AUTO_FROZEN"] = "auto_frozen";
    /** When the invoice is frozen manually */
    InvoiceEventType["MANUAL_FROZEN"] = "manual_frozen";
    /** When the invoice is unfrozen manually */
    InvoiceEventType["UNFROZEN"] = "unfrozen";
    /** When an expected payment date is saved by the user */
    InvoiceEventType["EXPECTED_PAYMENT_DATE_CHANGED"] = "expected_payment_date_changed";
})(InvoiceEventType || (InvoiceEventType = {}));
//# sourceMappingURL=invoiceEvent.js.map